export const FEED_PREVIEW_LIMIT = 2

export const FEED_FULL_PATH = '/novidades'
